const VegIcon = () => {
  return (
    <>
      <rect
        id='Rectangle 21338'
        x='0.5'
        y='0.5'
        width='31'
        height='31'
        stroke='#12B52C'
      />
      <circle
        id='Ellipse 400'
        cx='15.9997'
        cy='15.9997'
        r='9.41176'
        fill='#12B52C'
      />
    </>
  );
};

export default VegIcon;
